







import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class OrdersChart extends Vue {
  @Prop() series: any [];
  @Prop() title: any;

  @Prop() categories: any[];

  get chartOptions() {
    return {
      chart: {
        type: 'spline'
      },
      title: {
        text: this.title
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: this.categories
      },
      yAxis: {
        title: {
          text: 'Amount Orders'
        }
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        spline: {
          marker: {
            radius: 1,
            lineColor: '#666666',
            lineWidth: 1
          }
        }
      },
      series: [{
        name: 'Orders',
        marker: {
          symbol: 'square'
        },
        data: this.series
      }],
    };
  }
}
